import React, { useEffect, useState } from "react";
import Axios from 'axios';
import '../../App.css';
import DynamicSelect from "./DynamicSelect";
import RangeSlider from "./RangeSlider";
import { Copy, Save } from "lucide-react";
import { Button, Tooltip } from "flowbite-react";

export default function Create(props) {

const [search, setSearch] = useState(""); 
const [output, setOutput] = useState('');
const [rangeValue, setRangeValue] = useState(50);
const [loginStatus, setLoginStatus] = useState();
const [type, setType] = useState(""); 

//axios.defaults.withCredentials = true;

const [isHidden, setIsHidden] = useState(false);

      const handleClick = () => {
        setType('copied');
        setIsHidden(!isHidden);
        navigator.clipboard.writeText(output)
      };

      const saveClick = () => {
        console.log(props.uEmail);
        if(output.length > 3){
          Axios.post("https://mygamename.com/php/save.php", {
            email: props.uEmail,
            name: output,
          }).then((response) => {
            console.log(response);
            setType('saved');
            setIsHidden(!isHidden);  
          });
        }
      };

      useEffect(() => {
        const fetchProtected = async () => {
          try {
            const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
            console.log(response);
            if (response.data.status === 'success') {
              //setEmail(response.data.email);
              setLoginStatus(true);
              props.setUEmail(response.data.email);
            } else {
              //window.location.href = '/login';
            }
          } catch (error) {
            console.error(error);
            //window.location.href = '/login';
          }
        };
      
        fetchProtected();
      }, []);

  return (
    <div className="mx-auto max-w-2xl py-16 sm:py-16 lg:py-16 relative">
        <div className="" id="container">
          <div className="m-6">
            <h1 className="mb-4 text-4xl text-center font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Name Creator</h1>
            <div className="mb-6">
            <div id="copiedText" className={isHidden ? '' : 'hidden'}><p className="font-mediump-4 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"><span className="font-medium">Well done!</span> The name has been {type}.</p></div>
          </div>
            <form action="#">
                <input
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                type="text"
                placeholder="Game Name"
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
              />
              {/* <button type="submit"><i className="fa fa-search"></i>Start</button> */}
              <RangeSlider
       min='4'
       max='16'
       value={rangeValue}
       onChange={(e) => {
       setRangeValue(+e.target.value)
       }}
       customClasses='slider'
     /> 
            </form>
          </div>
        </div>
        <div className="m-6">
        <DynamicSelect search={search} setSearch={setSearch} output={output} setOutput={setOutput}/>
        </div>
        <div className="m-6">
        <h3>{output}</h3>
        <div className="flex-row flex">
        { props.loginStatus ? <button className="save-btn flex-row flex hover:bg-gray-50" onClick={saveClick}><Save /><span className="mr-2 mt-1 ml-6">Save</span></button> : <span></span>}
        <Tooltip style="
    display: flex;
    flex-direction: row;
" content="Copy to Clipboard" className="tooltip-fix">
        <button className="save-btn flex-row flex hover:bg-gray-50" data-toggle="#copiedText" data-toggle-class="hidden" onClick={handleClick}><Copy /><span className="mr-2 mt-1 ml-6">Copy</span></button>
        </Tooltip>
        </div>
        </div>
    </div>
  );
}